var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg004Bear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m422.852 450.161c54.583-46.948 89.148-116.518 89.148-194.161 0-141.385-114.615-256-256-256s-256 114.615-256 256c0 77.643 34.565 147.213 89.148 194.161z",
    fill: "#a3d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-11.141-.712-22.116-2.092-32.882l-94.887-94.887-311.48 55.287 59.967 59.967 195.829 40.367 63.515 166.308c54.583-46.947 89.148-116.517 89.148-194.16z",
    fill: "#65b1fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.663 455.611c0-57.072 46.266-103.337 103.337-103.337s103.337 46.266 103.337 103.337v34.659c23.205-10.251 44.608-23.835 63.583-40.167l-37.122-207.052h-259.596l-37.122 207.052c18.975 16.332 40.378 29.916 63.583 40.167z",
    fill: "#a65d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.337 456.611v33.659c23.205-10.251 44.608-23.835 63.583-40.167l-37.122-207.052h-129.798v110.222c57.072 0 103.337 46.266 103.337 103.338z",
    fill: "#784132"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 351.273c-57.072 0-103.337 46.266-103.337 103.337v35.676c31.605 13.961 66.565 21.714 103.337 21.714s71.733-7.753 103.337-21.713v-35.676c0-57.072-46.265-103.338-103.337-103.338z",
    fill: "#c38778"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 351.273v160.727c36.772 0 71.732-7.753 103.337-21.713v-35.677c0-57.071-46.265-103.337-103.337-103.337z",
    fill: "#a65d4e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m143.892 122.665c16.804 11.144 46.094 50.181 34.952 66.985-11.143 16.804-58.498 5.012-75.303-6.132-16.804-11.144-21.394-33.8-10.251-50.605s33.797-21.392 50.602-10.248z",
    fill: "#a65d4e"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368.108 122.665c-16.804 11.144-46.094 50.181-34.952 66.985s58.498 5.012 75.303-6.132c16.804-11.144 21.394-33.8 10.251-50.605s-33.797-21.392-50.602-10.248z",
    fill: "#784132"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.348 229.77c0 70.967-64.179 97.087-143.348 97.087s-143.348-26.12-143.348-97.087 64.179-152.77 143.348-152.77 143.348 81.802 143.348 152.77z",
    fill: "#c38778"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 77v249.857c79.169 0 143.348-26.12 143.348-97.087 0-70.968-64.179-152.77-143.348-152.77z",
    fill: "#a65d4e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 187.471,
    cy: 166.894,
    fill: "#414952",
    r: 14.953
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 324.529,
    cy: 166.894,
    fill: "#23272b",
    r: 14.953
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m250.247 169.585h11.506c23.314 0 41.307 17.542 38.272 37.314l-5.753 37.483c-2.522 16.432-18.896 28.719-38.272 28.719-19.376 0-35.75-12.287-38.272-28.719l-5.753-37.483c-3.035-19.771 14.958-37.314 38.272-37.314z",
    fill: "#a65d4e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m261.753 169.585h-5.753v103.516c19.376 0 35.75-12.287 38.272-28.719l5.753-37.483c3.035-19.771-14.958-37.314-38.272-37.314z",
    fill: "#784132"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.379 210.204c0 11.753-11.81 21.281-26.379 21.281s-26.379-9.528-26.379-21.281 11.81-12.702 26.379-12.702 26.379.949 26.379 12.702z",
    fill: "#414952"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 197.502v33.983c14.569 0 26.379-9.528 26.379-21.281s-11.81-12.702-26.379-12.702z",
    fill: "#23272b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Bear);
export default __webpack_public_path__ + "static/media/004-bear.3b05a1a720e69d986e55d783ae84b60a.svg";
export { ForwardRef as ReactComponent };